import { atom } from 'jotai';
import { ListParamsReport } from '../types';

export const reportsPaginationAtom = atom<ListParamsReport>({
  sort: {
    createdAt: 'desc',
  },
  pagination: {
    page: 1,
  },
} as ListParamsReport);
